import { EditProps } from 'react-admin';

import { CustomersEdit } from 'resources/customers/components/CustomersEdit.component';

export type OfflineCustomersEditProps = EditProps;

export function OfflineCustomersEdit(props: OfflineCustomersEditProps) {
  return <CustomersEdit {...props} />;
}
